import { ReactNode } from 'react';

import { useLoggedIn } from '../../hooks/useLoggedIn';
export const RealUserOnly: React.FC<{
	children: ReactNode;
}> = ({ children }) => {
	const loggedIn = useLoggedIn();
	return <>{loggedIn.realUser && <> {children}</>}</>;
};
